import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { DigitalDepositStackRoutes, DigitalDepositStackScreenProps } from './type';
import { DigitalDepositWebListScreen } from './DigitalDepositWebList.screen';
import { DigitalDepositNativeListScreen } from './DigitalDepositNativeList.screen';

export const DigitalDepositList: React.FC<DigitalDepositStackScreenProps<DigitalDepositStackRoutes.List>> = ({ navigation, route }) => {
  const { onLayout, account, record, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <DigitalDepositNativeListScreen onClose={onGoBack} onLayout={onLayout} record={record} account={account} refresh={refresh} />;
  }

  return <DigitalDepositWebListScreen onClose={closeModal} onLayout={onLayout} record={record} account={account} refresh={refresh} />;
};
